import { Injectable } from '@angular/core';
import { Observable, of, from, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IParticipant } from '../../../models/IParticipant';
import { IProgram, IClass } from '../../../models/IProgram';
import { get } from 'aws-amplify/api';


@Injectable({
    providedIn: 'root'
})
export class ParticipantService {

    getList(): Observable<IParticipant> {
        const op = get({
            apiName: 'portal',
            path: 'persons',
            options: {}
        });
        return from(op.response.then(async (r) => (await r.body.json()) as any)).pipe(
            map((data: any) => data as IParticipant),
            catchError((error) => throwError(() => error))
        );
    }
 
    getExternalFacilitatorCourses(programId: string): Observable<IClass[]> {
        const op = get({
            apiName: 'portal',
            path: `persons/facilitator/${programId}/courses`,
            options: {}
        });
        return from(op.response.then(async (r) => (await r.body.json()) as any)).pipe(
            map((body: any) => {
                const list = Array.isArray(body) ? body : (body?.data ?? []);
                return (list as any[]).map((c: any) => ({
                    ...c,
                    location: c.location || 'TBD'
                })) as IClass[];
            }),
            catchError((error) => throwError(() => error))
        );
    }
 
    getExternalFacilitatorPrograms(): Observable<IProgram[]> {
        const op = get({
            apiName: 'portal',
            path: 'persons/facilitator/programs',
            options: {}
        });
        return from(op.response.then(async (r) => (await r.body.json()) as any)).pipe(
            catchError(() => of([])),
            map((data: any) => (Array.isArray(data) ? data : (data?.data ?? [])) as IProgram[])
        );
    }
}
